import type { EntityRegistry } from '@sites/entity-migrator';

import { formRegistry } from './form/register';
import { indentRegistry } from './indent/register';
import { lineRegistry } from './line/register';
import { paymentFormRegistry } from './payment-form/register';

/**
 * Widgets that have a versioned entity, keyed by widget kind (legacy `name` / the
 * `<kind>` of a versioned `widget:<kind>` entityType). A widget missing here only
 * exists in its legacy shape.
 *
 * Deep-import this module (`@sites/entity-core/src/widget/registries`) rather
 * than the barrel on initial-chunk paths — it pulls in only the registered
 * widgets' schemas.
 */
export const widgetRegistries: Partial<Record<string, EntityRegistry<unknown>>> = {
    line: lineRegistry,
    indent: indentRegistry,
};

/**
 * Legacy-only widgets whose schema normalises persisted data on load (defaults for fields old
 * widgets never had, relocated fields) — run through `normalizeLegacyEntity`, which keeps whatever
 * the schema does not describe.
 */
export const legacyWidgetRegistries: Partial<Record<string, EntityRegistry<unknown>>> = {
    form: formRegistry,
    payment: paymentFormRegistry,
};
